// import React from "react";
// import { Modal, Button } from "react-bootstrap";

// const ReusableModal = ({
//   show,
//   onHide,
//   title = "Notice",
//   message,
//   okText = "OK",
//   cancelText,
//   onOk,
//   onCancel,
//   centered = true,
//   backdrop = "static", // prevent outside click close by default
//   size = "md",
// }) => {
//   const handleOkClick = () => {
//     if (onOk) {
//       onOk(); // dynamic action
//     }
//     if (!onOk) {
//       onHide(); // default close
//     }
//   };

//   const handleCancelClick = () => {
//     if (onCancel) {
//       onCancel();
//     } else {
//       onHide();
//     }
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={onHide}
//       centered={centered}
//       backdrop={backdrop}
//       size={size}
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>{title}</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         {typeof message === "string" ? <p>{message}</p> : message}
//       </Modal.Body>

//       <Modal.Footer>
//         {cancelText && (
//           <Button variant="secondary" onClick={handleCancelClick}>
//             {cancelText}
//           </Button>
//         )}

//         <Button variant="primary" onClick={handleOkClick}>
//           {okText}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default ReusableModal;

import React from "react";
import "./ReusableModal.css";

/**
 * ReusableModal — drop-in replacement for the Bootstrap Modal version.
 * Same props interface, zero Bootstrap dependency.
 *
 * Props:
 *  show        — boolean
 *  onHide      — called on backdrop click / × button
 *  title       — string
 *  message     — string or JSX
 *  okText      — string  (default "OK")
 *  cancelText  — string  (optional — if omitted, no cancel button)
 *  onOk        — function
 *  onCancel    — function (falls back to onHide)
 *  backdrop    — "static" (default) | true  — static prevents backdrop close
 *  variant     — "default" | "danger" | "warning" | "success"
 *               controls the header colour & ok-button colour
 */
const ReusableModal = ({
  show,
  onHide,
  title = "Notice",
  message,
  okText = "OK",
  cancelText,
  onOk,
  onCancel,
  backdrop = "static",
  variant = "default",
}) => {
  if (!show) return null;

  const handleOkClick = () => {
    if (onOk) onOk();
    else onHide();
  };

  const handleCancelClick = () => {
    if (onCancel) onCancel();
    else onHide();
  };

  const handleOverlayClick = (e) => {
    if (backdrop !== "static" && e.target === e.currentTarget) onHide();
  };

  return (
    <div className="rm-overlay" onClick={handleOverlayClick}>
      <div className="rm-box">

        {/* Header */}
        <div className={`rm-header rm-header--${variant}`}>
          <h5 className="rm-title">{title}</h5>
          <button className="rm-close" onClick={onHide}>×</button>
        </div>

        {/* Body */}
        <div className="rm-body">
          {typeof message === "string" ? (
            <p className="rm-message">{message}</p>
          ) : (
            message
          )}
        </div>

        {/* Footer */}
        <div className="rm-footer">
          {cancelText && (
            <button className="rm-btn rm-btn-cancel" onClick={handleCancelClick}>
              {cancelText}
            </button>
          )}
          <button className={`rm-btn rm-btn-ok rm-btn-ok--${variant}`} onClick={handleOkClick}>
            {okText}
          </button>
        </div>

      </div>
    </div>
  );
};

export default ReusableModal;